/**
 * A helper to create a service factory function from a class constructor.
 * @param constructor The class to create a factory function for.
 * @returns A factory function that creates an instance of the class.
 */
export function ConstructorFactory(constructor) {
    return (...args) => new constructor(...args);
}
// This allows us to map from a service contract back to a contract identity.
const Contract = Symbol();
//# sourceMappingURL=serviceDefinition.js.map